import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { FormControl } from 'react-bootstrap'

const SugestingInput = ({ info, onSelect, options, isMatching, labelattr, valueattr, compntClass, placeholder, noInputAddon }) => {
  function handleUpdateInput (evt) {
    info.inputval = evt.target.value
  }

  function handleKeyPress (evt) {
    info.keyPressed = true
  }

  labelattr = labelattr || 'text'
  valueattr = valueattr || 'value'
  const opts = info.availableOptions

  return (
    <div style={{ position: 'relative', clear: 'both' }}>
      <div className={labelattr === 'text' && `input-group ${noInputAddon && 'addon-hidden'}`}>
        {!noInputAddon && labelattr === 'text' && <span className='input-group-addon'>Add lang.:</span>}
        <FormControl componentClass={compntClass || 'input'} value={info.inputval || ''}
          onChange={handleUpdateInput} onKeyDown={handleKeyPress} placeholder={placeholder} />
      </div>
      {info.keyPressed && opts.length > 0 && opts[0][labelattr] !== info.inputval ? (
        <select multiple={true}>
          {info.availableOptions.map((i, idx) => (
            <option key={idx} value={i[valueattr]} onClick={() => onSelect(i)}>
              {i[labelattr]} &nbsp;{i.slug ? ' [' + i.slug + '] ' : ' '}
            </option>
          ))}
        </select>
      ) : null}
    </div>
  )
}
SugestingInput.propTypes = {
  isMatching: PropTypes.func.isRequired,
  noInputAddon: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired
}
export default observer(SugestingInput)
